export const quotes = [
    {
        description: 'Zmiana jest konieczna, podobnie jak odnowienie liści na wiosnę.',
        author: 'Vincent van Gogh'
    },
    {
        description: 'Kiedyś – nie ma takiego dnia tygodnia.',
        author: 'Janet Dailey'
    },
    {
        description: 'Jeśli życie daje ci cytryny, zrób z nich lemoniadę.',
        author: 'Dale Carnegie'
    },
    {
        description: 'Wszystko, co przeżywamy, to tylko jakieś etapy, jakieś stacje. To, co dziś wydaje się wielkim osiągnięciem, jutro odpada, bo poszliśmy już dalej. Trzeba być zawsze w drodze.',
        author: 'Anna Kamieńska'
    },
    {
        description: 'Nigdy nie rezygnuj z celu tylko dlatego, że osiągnięcie go wymaga czasu. Czas i tak upłynie.',
        author: 'H. Jackson Brown'
    },
    {
        description: 'Jutro to jedyny dzień w roku, który pociąga lenia.',
        author: 'Jimmy Lyons'
    },
    {
        description: 'Inspiracja istnieje, ale musi Cię zastać przy pracy.',
        author: 'Pablo Picasso'
    },
    {
        description: 'Masz władzę nad tym, co znajduje się w rękach losu, ale temu, co znajduje się w twych własnych, pozwalasz ulecieć. Za czym wyglądasz? Czego wyczekujesz? Przyszłość jest niepewna: żyj teraz.',
        author: 'Seneka'
    },
    {
        description: 'Musimy dążyć do ideału, choćbyśmy nigdy nie mieli go dosięgnąć.',
        author: 'Lucy Maud Montgomery, Ania z Avonlea'
    },
    {
        description: 'Jeden czeka, aż czas przyjdzie właściwy. Drugi działa i do działania zbiera siły.',
        author: 'Dante'
    },
    {
        description: 'Być gotowym to wiele, umieć czekać – to więcej, wykorzystać właściwy moment – to wszystko.',
        author: 'Arthur Schnitzler'
    },
    {
        description: 'Twój czas jest ograniczony, więc nie marnuj go na byciem kimś, kim nie jesteś.',
        author: 'Steve Jobs'
    },
    {
        description: 'Zamiast ciągle na coś czekać – zacznij żyć, właśnie dziś. Jest o wiele później, niż ci się wydaje.',
        author: 'Jan Kaczkowski'
    },
    {
        description: 'Owszem, zdarzają się scenariusze, w których pisarz nie od razu znalazł wydawcę kuszącego zaliczkami i straszącego procesami. Norwid większość twórczości napisał do szuflady. Ale to nadal nie znaczy, że poznalibyśmy ją bez wydawcy. Tyle że ten pojawił się dwa pokolenia później.',
        author: 'Wojciech Orliński'
    },
    {
        description: 'W większości przypadków sztuka wydawania to sztuka ponoszenia ryzyka za autora.',
        author: 'Wojciech Orliński'
    },
    {
        description: 'Nic nie jest podawane na tacy – każdy zawsze trafia na jakieś przeszkody po drodze. Kiedy się pojawią, zastanów się jak je pokonać, a nie myśl o tym, że to już koniec drogi.',
        author: 'Michael Jordan'
    },
    {
        description: 'Motywacja do wygranej jest ważna, ale motywacja do przygotowania się jest niezbędna.',
        author: 'Joe Paterno'
    },
    {
        description: 'W życiu musi być dobrze i niedobrze. Bo jak jest tylko dobrze, to jest niedobrze.',
        author: 'Jan Twardowski'
    }
];
